/** @file Main Mantine theme entry point composing all design tokens. */
import { createTheme } from '@mantine/core';
import { coral, teal, sand, charcoal, darkNeutral } from './colors';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { spacing } from './spacing';
import { shadows } from './shadows';
import { radius } from './radius';
import { components } from './components';
import { cssVariablesResolver } from './cssVariablesResolver';

export const mantineTheme = createTheme({
  primaryColor: 'coral',
  colors: {
    coral,
    teal,
    sand,
    charcoal,
    dark: darkNeutral
  },
  white: '#FAFAF8',
  black: '#1E293B',
  fontFamily: typography.fontFamily,
  headings: typography.headings,
  breakpoints,
  spacing,
  shadows,
  radius,
  defaultRadius: 'control',
  // Under prefers-reduced-motion, Mantine's own transitions (Modal, Drawer, the
  // slide-up sheet, Popover, Collapse) run at 0ms; the app's keyframes guard themselves.
  respectReducedMotion: true,
  components
});

export { cssVariablesResolver };
export { coral, teal, sand, charcoal, darkNeutral } from './colors';
export { semanticColors, semanticPalette } from './semanticColors';
export { typography } from './typography';
export { motion } from './motion';
export { spacing } from './spacing';
export { breakpoints } from './breakpoints';
export { shadows, shadowValues } from './shadows';
export { radius } from './radius';
export { layout } from './layout';
export { zIndex } from './zIndex';
export { dataViz, dataVizDark } from './dataViz';
export { mapTokens, mapTokensDark } from './maps';
export { mapStylesDark } from './mapStylesDark';
export { components } from './components';
export { studioTheme } from './studioTheme';

export default mantineTheme;
